import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Panel, EmptyState, StatusBadge } from "@/components/admin/shared";
import { waLink, waNudge } from "@/lib/constants";
import { AlertTriangle, MessageCircle } from "lucide-react";

export const StuckLeads = ({ className = "" }) => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [active, setActive] = useState(undefined);
  const load = async () => setData((await api.get("/leads/stuck?days=7")).data);
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);

  if (!data) return null;
  const group = (active === undefined ? null : data.members.find((g) => g.member_id === active)) || data.members[0];

  return (
    <Panel className={className}
      title={<span className="flex items-center gap-2"><AlertTriangle size={16} className="text-rose-500" /> Stuck Leads · 7+ days in the same stage</span>}
      action={<span className="text-xs font-bold text-rose-600" data-testid="stuck-total">{data.total} stuck</span>}>
      {data.total === 0 ? <EmptyState text="No stuck leads, great work!" /> : (
        <div data-testid="stuck-leads">
          <div className="flex flex-wrap gap-2 mb-3">
            {data.members.map((g) => (
              <button key={g.member_id || "unassigned"} onClick={() => setActive(g.member_id)} data-testid="stuck-member-tab"
                className={`h-8 px-3 rounded-full text-xs font-bold transition-colors ${group === g ? "bg-[#081226] text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>
                {g.name} · {g.items.length}
              </button>
            ))}
          </div>
          <div className="space-y-2 max-h-[320px] overflow-y-auto">
            {group.items.map((l) => (
              <div key={l.lead_id} data-testid="stuck-lead-row" className="flex items-center gap-3 p-3 rounded-xl bg-slate-50">
                <span className="text-[11px] font-bold px-2 py-1 rounded-full bg-rose-100 text-rose-700 w-12 text-center shrink-0" data-testid="stuck-lead-days">{l.days}d</span>
                <div className="flex-1 min-w-0 cursor-pointer" onClick={() => navigate(`/admin/visitors/${l.visitor_id}`)}>
                  <p className="text-sm font-semibold text-[#081226] truncate">{l.name}</p>
                  <p className="text-xs text-slate-400 truncate">{l.visitor_id} · {l.mobile}</p>
                </div>
                <div className="hidden sm:block"><StatusBadge status={l.status} /></div>
                <a href={waLink(l.mobile, waNudge(l.name, l.status, l.interests?.[0] || (l.purpose !== "Enquiry" ? l.purpose : null)))} target="_blank" rel="noreferrer" data-testid="stuck-nudge-btn"
                  className="h-9 px-3 rounded-lg bg-[#25D366] text-white text-xs font-bold flex items-center gap-1.5 shrink-0"><MessageCircle size={15} /> Nudge</a>
              </div>
            ))}
          </div>
        </div>
      )}
    </Panel>
  );
};
